import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import "./HelpAssistant.css";
import femaleuser from "../../images/img/female-user.png";
import helpicon from "../../images/img/chat-helpicon-top.png";
import apiService from "../APIService";
import backtopmenu from "../../images/img/backtopmenu-arrow.svg";
import sendIcon from "../../images/icons/send.svg";
import sendIconGrey from "../../images/icons/send-gray.svg";
import micIcon from "../../images/icons/speak.svg";
import attachIcon from "../../images/icons/attatchment.svg";
import Conversation from "../Conversation/Conversation";
import "../CoachScreen.css";
import "../css/gethelp-responsive.css";
import {
  sendOnAppClose,
  sendOnAppOpen,
} from "../../Simplify360Chat/Services/HWIframeBridge";
import { TextareaAutosize } from "@material-ui/core";
import { stubTrue } from "lodash";
import { Constants } from "../../Constants/Constants";
import { findAllInRenderedTree } from "react-dom/test-utils";
import { ParsedQuery } from "query-string";

const HelpAssistant = (props) => {
  const [isChatOpen, setIsChatOpen] = useState(true);
  const [typedFlag, setTypedFlag] = useState("");
  const [show, setShow] = useState(false);
  const [clearHistory, setClearHistory] = useState(false);
  const [showClose, setShowClose] = useState(false);
  const [showMinimize, setShowMinimize] = useState(false);
  const [conversation, setConversation] = useState(false);
  const [showAssistantToolTip, setShowAssistantToolTip] = useState(false);
  const [showChatToolTip, setShowChatToolTip] = useState(false);
  const [conversationData, setConversationData] = useState();
  const [chatHistory, setChatHistory] = useState([]);
  const [showRechargeToast, setShowRechargeToast] = useState(false);
  const [sendText, setSendText] = useState();
  const [showWhatsappBanner, setShowWhatsappBanner] = useState(true);
  const [showWhatsappRegisterPopup, setShowWhatsappRegisterPopup] =
    useState(false);
  const [historyData, setHistoryData] = useState();
  const [changedRefresh, setChangedRefresh] = useState(false);
  const [showSecondOk, setShowSecondOk] = useState(false);
  const [thirdOkay, setThirdOkay] = useState(false);
  const [sth, setSth] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [historyLoader, setHistoryLoader] = useState(false);
  const [loginLoader, setLoginLoader] = useState(true);
  const [name, setName] = useState();
  const [login, setLogin] = useState(false);
  const [enableDefaultTextBox, setEnableDefaultTextBox] = useState(false);
  const [auth, setAuth] = useState(props.authenticated);
  const [textMessage, setTextMessage] = useState("");
  const [backToMenuRender, setBackToMenuRender] = useState(false);
  const [minimized, setMinimized] = useState(
    props.launchOnButton !== undefined && props.launchOnButton ? false : true
  );
  const [maximized, setMaximized] = useState(true);
  const [outSideLink, setOutSideLink] = useState(true);
  const [overlayVisible, setOverlayVisible] = useState(true);
  const [tempLinkDetails, setTempLinkDetails] = useState(null);
  const [actionFromConfig, setActionFromConfig] = useState(null);
  const [jumpNode, setJumpNode] = useState(true);
  const [chatData, setChatData] = useState([]);
  const [loginCount, setLoginCount] = useState(0);
  const [showOverlay, setshowOverlay] = useState(false);
  const [chatLoader, setChatLoader] = useState(false);
  //new addition 1
  const [isLoading, setIsLoading] = useState(false);
  const [currentData, setCurrentData] = useState([]);
  const [showChatInProgressToolTip, setShowChatInProgressToolTip] =
    useState(false);
    const [loggedInTillrefresh,setLoggedInTillrefresh] = useState(false)
  // console.log("action from config in HELPASSISTANT.JS", props);

  const messageRef = useRef(null);
  const configFromLocal = localStorage.getItem("s360-config-data");

  const extractFromUrl = (url) => {
    var splitArray = [];

    const queryParams = new URLSearchParams(url);

    for (const [key, value] of queryParams) {
      splitArray.push({ key, value });
      // {key: 'term', value: 'pizza'} {key: 'location', value: 'Bangalore'}
    }
    var ExtractedUrlTemp = splitArray.reduce(
      (a, item) => Object.assign(a, { [item.key]: item.value }),
      {}
    );

    // console.log("splitArray", splitArray, url);
    //4.get subid,action,authenticated from url
    //create and object extractedURl (temp variable) which has subid,action,authenticated
    let extractedURl = new Object();
    //this code can be modified based on url format
    //*****************************************
    extractedURl.authenticated = ExtractedUrlTemp.authenticated || false;
    extractedURl.subscriberId = ExtractedUrlTemp.subId;
    extractedURl.action = ExtractedUrlTemp.action || "1";
    //*****************************************
    //     console.log("extractedUrl", extractedURl);
    // console.log("enableDefaultTextBox",enableDefaultTextBox)
    if (
      extractedURl.action != undefined &&
      (extractedURl.authenticated != undefined ||
        extractedURl.subId != undefined)
    ) {
      //TODO:create a variable to identify that login should happen thrugh linkdetails and not props

      setTempLinkDetails(extractedURl);
      return extractedURl;
    } else {
      return false;
    }
  };

  //     const sendExternalApi=(subId,action,authenticated)=>{
  //         console.log("sendExternalApi",subId,action,authenticated);

  //       //6.send login and chatapi with extracted parameter
  //       apiService.login(subId,authenticated).then((response) => {
  //         console.log("login response", response);

  //     })
  //     //  apiService.chat(action).then((response) => {
  //     //     console.log("chat response", response);

  //     // })

  // }
  const linkDetection = (url) => {
    if (url.includes("action")) {
      //setting OutSideLink to true so that coaching screen is disabled and chat screen is enabled

      setOutSideLink(true);
      setShow(true);
      // handleLogin();
      setshowOverlay(false);
      sendOnAppOpen();

      setShowClose(false);
      setShowMinimize(false);
      setMinimized(false);
      extractFromUrl(url);

      // if(extractFromUrl(url)){

      //     sendExternalApi(extractFromUrl(url).subId,extractFromUrl(url).action,extractFromUrl(url).authenticated);
      // }
      // }
    } else {
      if (props.action !== undefined && props.action !== null) {
        setActionFromConfig(props.action);
        if (props.hideLoading) {
          setOutSideLink(false);
        } else {
          setOutSideLink(false);
          setOverlayVisible(false);
        }
        actionInConfig(props);
      } else {
        if (props.hideLoading) {
          setshowOverlay(false);
          sendOnAppOpen();
          setShow(true);
          setShowClose(false);
          setShowMinimize(false);
          setMinimized(false);
        }
        setOutSideLink(false);
        setOverlayVisible(false);
      }
    }
    //2.cheek for action in url
    //3.if url contains action set outside link variable true and call extract from url

    //5. send external api function
  };
  const actionInConfig = (props) => {
    if (props?.action !== undefined || props?.action !== null) {
      if (props.hideLoading) {
        setShow(true);
        setOutSideLink(true);
        // handleLogin();
        setshowOverlay(false);
        sendOnAppOpen();
        setShowClose(false);
        setShowMinimize(false);
        setMinimized(false);
      }
      let extractedURl = new Object();
      //this code can be modified based on url format
      //*****************************************
      // extractedURl.authenticated = props.authenticated;
      // extractedURl.subId = props.subscriberId;
      // extractedURl.action = props.action;
      // // console.log(extractedURl);
      // setTempLinkDetails(extractedURl);
    }
  };
  // useEffect(() => {
  //   //1.call a function to check if action is there in url->linkDetection()
  //   // alert("reached here in help")
  //   // localStorage.setItem("load", true)
  //   // linkDetection(window.location.href);

  //   // if(localStorage.getItem('redirectLinkFullScreen'))
  //   // {
  //   //     redirectLinkFunction()
  //   // }
  // }, []);

  useEffect(() => {
    localStorage.setItem("s360ChatLoggedIn","false")
    setshowOverlay(true);
    // const token = "325131af286f495783e448d5c2852a8c"; //UAT
    // // const token = "85dcf53015444ab4ad428d3340d8431e"; //PROD
    // if (props.launchOnButton === undefined || !props.launchOnButton) {
    //   apiService.loginCount(props.subscriberId, token).then((res) => {
    //     console.log(res.data.loginCount);
    //     setLoginCount(res.data.loginCount);
    //     if (res.data.loginCount < Constants.CoachScreenLimit) {
    //       setshowOverlay(true);
    //       window.parent.postMessage(
    //         {
    //           inCoachScreen: "true",
              
    //         },
    //         "*" //or "www.parentpage.com"
    //       );
    //     }
    //      else {
    //       window.parent.postMessage(
    //         {
    //           chatMinimized: "true",
    //         },
    //         "*" //or "www.parentpage.com"
    //       );
    //     }
    //     //comment else part for PROD
    //   });
      // make the below filed true in PROD for overlay to appear
      // setshowOverlay(true);
    // }
  }, []);

useEffect(()=>{
   if(!minimized)

   startLogin()
},[minimized])

  useEffect(() => {
    setAuth(props.authenticated);
    // localStorage.removeItem("filterApllied");
  }, [props.authenticated]);
  //new addition 2

  useEffect(() => {
    linkDetection(window.location.href);
    setConversation(true);
    if (props.launchOnButton || window.location.href.includes("action")) {
      //  console.log(props.action ,props).outSideLink,localStorage.getItem("linkChatOnce"),"check here")
      /*TODO:2 IF COMING FROM OUTSIDELINK(VARIABLE IS TRUE) && && localStorage.getItem("linkChatOnce") === null && localStorage.getItem("linkLoginOnce") === null ---> NEWSENDOUTSIDELINKAPI --
      --> TAKE SUBID ETC FROM TEMPLINKDETAILS
      
      if (VARIABLE && localStorage.getItem("linkChatOnce") === null && localStorage.getItem("linkLoginOnce") === null) {
        NEWSENDOUTSIDELINKAPI() -->NEW
      }
      ELSE IF(PROPS.ACTION && !VARIABLE && localStorage.getItem("linkChatOnce") === null && localStorage.getItem("linkLoginOnce") === null)
      {
        sendOutsideLinkApi() -->OLD
      }
      */

      // localStorage.setItem("load", true)

      if (
        window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendNewOutsideLinkApi();
      } else if (
        props.action &&
        !window.location.href.includes("action") &&
        localStorage.getItem("linkChatOnce") === null &&
        localStorage.getItem("linkLoginOnce") === null
      ) {
        sendOutsideLinkApi();
      }
    }
  }, []);
 
useEffect(()=>{
  if(!showOverlay)
  console.log("login end and show overlay removed",new Date().getUTCSeconds())
},[showOverlay])
  const sendOutsideLinkApi = () => {
     
    setLoggedInTillrefresh(true)
    apiService
      .loginForLink(
        props.subscriberId,
        props.authenticated,
        props.action,
       props.openChat ?true: localStorage.getItem("jumpNode")
      )
      .then((response) => {

        console.log("login done",new Date().getUTCSeconds())
        chatReopenFunction(response.data.token,changedRefresh);
        localStorage.setItem("token", response.data.token);
        if (response.data.userInfo !== undefined) {
          localStorage.setItem(
            "userName",
            JSON.stringify(response?.data?.userInfo?.customerName)
          );
        } else {
          localStorage.setItem("userName", JSON.stringify("Testing"));
        }

         
         
        setLogin(true);
        //setLogin(true)
        // console.log("name",response.data.userInfo.accountDetails.accountDetails[0].fname,n );
        // if (auth) {
        //   apiService.refreshChat().then(res => {
        //     setLoginLoader(false)
        //     setLogin(true)
        //     // console.log("response", response);
        //   })
        // }
        // else {
        //   setLoginLoader(false)
        //   setLogin(true)
        // }
        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
     
        console.log("login end",new Date().getUTCSeconds())
        // apiService.chatForLink(response.data.token).then(response => {
        //   setIsLoading(false)
        //   const data = response.data && response.data.chatResponse && response.data.chatResponse.entries;
        //   console.log(data, 'data check')

        //   setCurrentData(data);

        //   //  console.log(currentData,'current check')

        // })
      });
    // localStorage.removeItem("linkChatOnce")
    // localStorage.removeItem("linkLoginOnce")
  };

  const sendNewOutsideLinkApi = () => {

 
    setChangedRefresh(false);
    const temp = extractFromUrl(window.location.href);
    // const tempLinkDetails = props.tempLinkDetails;
    // if(outSideLink)
    // {
    //   alert('outside')
    // }
    console.log(temp, "tempnew");
    apiService
      .loginForLink(
        temp.subscriberId,
        temp.authenticated,
        temp.action,
       props.openChat ?true: localStorage.getItem("jumpNode")
      )
      .then((response) => {
        chatReopenFunction(response.data.token,changedRefresh);
        localStorage.setItem("token",response.data.token);

        if (response.data.userInfo !== undefined) {
          localStorage.setItem(
            "userName",
            JSON.stringify(response?.data?.userInfo?.customerName)
          );
        } else {
          localStorage.setItem("userName", JSON.stringify("Testing"));
        }

         
        setLogin(true);
        //setLogin(true)
        // console.log("name",response.data.userInfo.accountDetails.accountDetails[0].fname,n );
        // if (auth) {
        //   apiService.refreshChat().then(res => {
        //     setLoginLoader(false)
        //     setLogin(true)
        //     // console.log("response", response);
        //   })
        // }
        // else {
        //   setLoginLoader(false)
        //   setLogin(true)
        // }

        if (!auth) {
          setLoginLoader(false);
          setLogin(true);
        }
         

        // apiService.chatForLink(response.data.token).then(response => {
        //   setIsLoading(false)
        //   const data = response.data && response.data.chatResponse && response.data.chatResponse.entries;
        //   console.log(data, 'data check')

        //   setCurrentData(data);

        //   //  console.log(currentData,'current check')

        // })
      });
    // localStorage.removeItem("linkChatOnce")
    // localStorage.removeItem("linkLoginOnce")
  };

  //


  // useEffect(()=>{
  //   if(props.launchOnButton === undefined || !props.launchOnButton){

  //     if(isChatOpen){
  //       window.parent.postMessage(
  //         {
  //           chatMinimized: "false",
  //           chatMaximized:"true"
  //         },
  //         "*" //or "www.parentpage.com"
  //       );
  //     }else{
  //       window.parent.postMessage(
  //         {
  //           chatMinimized: "true",
  //           chatMaximized:"false"
  //         },
  //         "*" //or "www.parentpage.com"
  //       );
  //     }
  //   }

  // },[isChatOpen])
  const handleCurrentStateChat = () => {
    setTextMessage({ key1: "", count: Math.random(0, 1), dontSend: true });
    // apiService.chat(null, null, null).then((response) => {
    //   console.log("chatresponse", response, response.data);
    // });
  };
  useEffect(() => {
    setThirdOkay(false);
    // console.log(typedFlag, "typedFlag");
  }, [typedFlag]);

  const coachScreenCloseFunc = () => {
    window.parent.postMessage(
      {
        resizeIframe: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };
  const closeEntireChat = () => {
    if (props.openChat) {
      return;
    }
    window.parent.postMessage(
      {
        closeChat: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };

  const handleLogin = () => {
    // setMaximized(true)
    // setMinimized(false)
    // console.log("Logging in....");
    // const subscriberId = props.subscriberId; //s360ConfigService.config.subscriberId;
    // const authentication = props.authenticated;
    // // if (!subscriberId) { return; }
    // setLoginLoader(true);
    // console.log("HA-handlelogin", subscriberId, authentication);
    // apiService.login(subscriberId, authentication).then((response) => {
    //  alert("gamma")
    // console.timeEnd("Login ended");
    // localStorage.setItem("token", response.data.token);
    // console.log(
    //   response,
    //   response.data,
    //   response.data.token,
    //   response?.data?.userInfo?.customerName
    // );
    // if (response.data.userInfo !== undefined) {
    //   localStorage.setItem(
    //     "userName",
    //     JSON.stringify(response?.data?.userInfo?.customerName)
    //   );
    // } else {
    //   localStorage.setItem("userName", JSON.stringify("Testing"));
    // }
    // if (auth) {
    // apiService.chat().then((res) => {
    //   setLoginLoader(false);
    //   setLogin(true);
    //   console.log("response", response);
    // });
    // } else {
    //   setLoginLoader(false);
    //   setLogin(true);
    // }
    // const n =
    //   response.data &&
    //   response.data.userInfo &&
    //   response.data.userInfo.accountDetails &&
    //   response.data.userInfo.accountDetails.accountDetails &&
    //   response.data.userInfo.accountDetails.accountDetails &&
    //   response.data.userInfo.accountDetails.accountDetails[0] &&
    //   response.data.userInfo.accountDetails.accountDetails[0].fname;
    // setName(n);
    // setLogin(true)
    // console.log("name",response.data.userInfo.accountDetails.accountDetails[0].fname,n );
    // });
  };

  const handleCloseChat = () => {
    handleRefresh();
    // setShow(false);
    setShowBackToButton(false);
    setClearHistory(false);
    setShowMinimize(true);
    props.launchOnButton
      ? setShowAssistantToolTip(false)
      : setShowAssistantToolTip(true);
    setConversationData();
    setChatHistory([]);
    setShowWhatsappRegisterPopup(false);
    //  localStorage.removeItem("filterApllied");
  };

  const handleWhatsappRegisterNow = () => {
    setShowWhatsappRegisterPopup(true);
  };

  const handleCloseWhatsappRegistrationDone = () => {
    setShowClose(true);
  };
  const [scrollTop, setScrollTop] = useState(0);
  const [showBackToButton, setShowBackToButton] = useState(false);

  const myRef = useRef(null);

  const executeScroll = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
    //  handleRefresh();
  };

  const backToMenuFunction = () => {
 
    //  myRef.current.scrollIntoView({ behavior: 'smooth' });

    setShowBackToButton(false); //not affecting

     
    
    // setClearHistory(!clearHistory)
    //  setTextMessage({ key1: "", count: Math.random(0, 1), dontSend: true })
    setClearHistory(true);
 

    // localStorage.removeItem("filterApllied");
    // handleRefresh();
    // setBackToMenuRender(Math.random())
    // setLoginLoader(true)
    // handleRefreshAgain()
    restartChatOnBackToMenu(localStorage.getItem("token"));
    setBackToMenuRender(!backToMenuRender);
  

    // setShowMinimize(true);
    // setShowChatToolTip(true)
    // console.log(showMinimize, "showMinimize");
    // console.log(showChatToolTip, "tooltip");

    // localStorage.setItem("filterApllied",false);

    // setShow(false)

    // setClearHistory(!clearHistory)
  };

  const minimizeChat = () => {
     
    // setJumpNode(true);
    localStorage.setItem("jumpNode", true);
    window.parent.postMessage(
      {
        closeChat: "true",
      },
      "*" //or "www.parentpage.com"
    );
  };

  const handleRefresh = () => {
    // setLoginLoader(false)
    // setLoginLoader(true)
  };

  const onScroll = (e) => {
 
    let element = e.target;
     console.log("scrolling....",element.scrollHeight,element.scrollTop,element.clientHeight)

    if (element.scrollTop > 300) {
      //    console.log("scrolling after 200")
      setShowBackToButton(true);
    } else {
      setShowBackToButton(false);
    }
  };

  const handleHistory = () => {
    setHistoryLoader(true);
    apiService
      .historyApi(props.sessionId, props.source)
      .then((response) => {
        setHistoryLoader(false);
        // console.log("historyresponse", response.data);
        setHistoryData(response.data);
        setShowHistory(true);
      })
      .catch((error) => {
        setHistoryLoader(false);
      });
  };

  useEffect(() => {
    if (props.viewType === "history") {
      handleHistory();

      setSth(true);
    }
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      onMessageSend();
    }
  };

  const onMessageSend = () => {
    let hasTextMessage = messageRef.current.value;
    // console.log("hasTextMessage", hasTextMessage);
    if (hasTextMessage) {
      // console.log("textMessage", textMessage);
      setTextMessage({
        key1: messageRef.current.value,
        count: Math.random(0, 1),
      });

      // console.log("textMessage-setstate", textMessage);
    }
    messageRef.current.value = "";
  };
const startLogin =()=>{



  props.openChat && setChangedRefresh(false);
  
  if (
      props.action &&
      !window.location.href.includes("action") 
      
    ) {
      if(loggedInTillrefresh){
        setChangedRefresh(true)
chatReopenFunction(localStorage.getItem("token"))
      }else if(localStorage.getItem("linkChatOnce") === null &&
      localStorage.getItem("linkLoginOnce") === null){
        sendOutsideLinkApi();
      }
    }else{
        sendNewOutsideLinkApi()
    }
}
  const handleChange = (e) => {
    // console.log("hiii", e.target.value);
    setTypedFlag(e.target.value);
    if (document.getElementById("tx").scrollHeight > 50) {
      document.getElementById("tx").style.overflowY = "scroll";
      // console.log("dd", document.getElementById("tx").style);
    }
  };

  const handleInputBox = (value) => {
    //change true /false for UAT PROD --->enable textbox
    setEnableDefaultTextBox(false);
  };
  const restartChatOnBackToMenu =(tokenData)=>{
    setLoginLoader(true);
    console.log("login done and chat started",new Date().getUTCSeconds())
    apiService.chatForLink(tokenData,true).then((response) => {
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      // console.log(data, "data in reopen");
      setChatData(data);
      setLoginLoader(false);
      // setCurrentData(data);
      console.log("login done and chat done",new Date().getUTCSeconds())
    });
  }
  const chatReopenFunction = (tokenData) => {
   
    localStorage.setItem("token",tokenData);
    //get token which is set after logging in
    setLoginLoader(true);
    console.log("login done and chat started",new Date().getUTCSeconds())
    apiService.chatForLink(tokenData,changedRefresh).then((response) => {
      const data =
        response.data &&
        response.data.chatResponse &&
        response.data.chatResponse.entries;
      // console.log(data, "data in reopen");
      setChatData(data);
      setLoginLoader(false);
      // setCurrentData(data);
      console.log("login done and chat done",new Date().getUTCSeconds())
    });

    //TODO : call apiService.chatReopenAPI
    //get the data from the api
    //pass it to conversation.jsx through props
  };
   
  const handleThirdOkay = () => {
    setThirdOkay(false);
  };
  const handleNewLink = () => {
    // window.open(window.location.href, '_blank');
    localStorage.setItem("redirectLinkFullScreen", true);
  };
  return (
    <Fragment>
      {props.viewType === "history" ? (
        <div>
          <div
           onScroll={onScroll}
            className="help-chat-box chatIn-header-hist help-assistantwrapp-hist hbc0 maximize"
            id="top"
          >
            {/* <div className="chat-overlay" style={{display:showOverlay?"block":"none"}}></div> */}
            {/* {console.log("ha-history")} */}
            <div
              className="help-card-header left-gradient"
              style={{ display: "block" }}
            >
              <span className="chat-avtar">
                <img src={helpicon} alt="" />
              </span>
              <span className="chat-avtar-detail bold">
                {" "}
                Get help Assistant{" "}
              </span>
            </div>
            <div
            
              className="help-card-body my-custom-scrollbar my-custom-scrollbar-primary" onScroll={onScroll}
              style={{ height: "95%" }}
            >
              {showBackToButton && (
                <>
                  <div className="bktotop" style={{ width: "100%" }}>
                    <button
                      onClick={async () => {
                        
                        await backToMenuFunction();
                      }}
                      className="button"
                    >
                      <span>
                        <img src={backtopmenu} alt="" />
                      </span> 
                      Back to menu
                    </button>
                  </div>
                </>
              )}

              <div className="firstblk chat-section" id="section0" ref={myRef}      >
                {conversation && (
                  <Conversation
                    //new addition3
                    
                    isLoading={isLoading}
                    currentData={currentData}
                    //
                    chatData={chatData}
                    jumpNode={jumpNode}
                    setLoginFromProps={(data) => setLogin(data)}
                    actionConfig={actionFromConfig}
                    {...props}
                    setLoginLoader={setLoginLoader}
                    setLogin={setLogin}
                    historyData={historyData}
                    setHistoryData={setHistoryData}
                    sth={sth}
                    showHistory={showHistory}
                    historyLoader={historyLoader}
                    loginLoader={loginLoader}
                    name={name}
                    login={login}
                    auth={auth}
                    setAuth={setAuth}
                    handleInputBox={handleInputBox}
                    handleDontSend={() =>
                      setTextMessage({
                        key1: "",
                        count: Math.random(0, 1),
                        dontSend: true,
                      })
                    }
                    outSideLink={outSideLink}
                    tempLinkDetails={tempLinkDetails}
                  />
                )}
                {/* {console.log("ha-con227")} */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {!overlayVisible && showOverlay && (
            <>
              {" "}
              <div className="black-overlay fix"></div>
              {/* {console.log("ha-overlay")} */}
              {/* {(localStorage.getItem('redirectLinkFullScreen')) && setShow(true) && handleLogin()&& setshowOverlay(false) && sendOnAppOpen() && setShowAssistantToolTip(true) && } */}
              {!overlayVisible && !showSecondOk ? (
                <div className="instr1">
                  {/* {console.log("ha-showSecondOk", showSecondOk)} */}
                  <div>
                    Click on the Get Help assistant to get your queries resolved
                  </div>
                  <div>
                    <button
                      className="btn btn-primary waves-effect waves-light w-auto mT10 btn1"
                      
                      onClick={ () => {
                        setshowOverlay(false);
                          window.parent.postMessage(
                            {
                              chatMinimized: "true",
                            },
                            "*" //or "www.parentpage.com"
                          );
                        setShowSecondOk(true);

                        // coachScreenCloseFunc();
                        sendOnAppOpen();
                        setShowAssistantToolTip(true);
                        setThirdOkay(true);
                        setTimeout(() => {
                          setShowAssistantToolTip(false);
                        }, 4000);

                        //  setShow(true);

                        //url has action then dont run it
                        if (props.action) {
                          setMinimized(true);
                          //action exists in url
                        } else {
                          // handleLogin();
                          // setMinimized(false);
                        }
                        //  if (
                        //   props.action &&
                        //   !window.location.href.includes("action") &&
                        //   localStorage.getItem("linkChatOnce") === null &&
                        //   localStorage.getItem("linkLoginOnce") === null
                        // ) {
                        //     sendOutsideLinkApi();
                        // }else{
                        //     sendNewOutsideLinkApi()
                        // }
                      }}
                    >
                      Ok, got it
                    </button>
                  </div>
                  <div className="arrow"></div>
                </div>
              ) : (
                <>
                  {/* <div className="overlaying"></div>
                  {!overlayVisible && (
                    <div className="instr2">
                      <div
                        class="demo-chart-label"
                        style={{ color: "#444444" }}
                      >
                        <div class="chat-label-wrapp clearfix">
                          {" "}
                          <span class="chat-label">Unable to view</span>{" "}
                          <span class="chat-label">Bills &amp; payments</span>{" "}
                          <span class="chat-label">Account &amp; profile</span>{" "}
                          <span class="chat-label">Packs &amp; channels</span>{" "}
                          <span class="chat-label">
                            Requests &amp; complaints
                          </span>{" "}
                        </div>
                      </div>
                      <div>Click on the topic where you need help</div>
                      <div>
                        <button
                          className="btn btn-primary waves-effect waves-light w-auto mT10 btn2 upShow"
                          onClick={() => {
                            coachScreenCloseFunc();
                            setshowOverlay(false);
                            sendOnAppOpen();
                            setShowAssistantToolTip(true);
                            setThirdOkay(true);
                            setTimeout(() => {
                              setShowAssistantToolTip(false);
                            }, 4000);
                          }}
                        >
                          Ok
                        </button>
                      </div>
                      <div className="arrow"></div>
                    </div>
                  )} */}
                </>
              )}{" "}
            </>
          )}

          <div className="pfixed">
            {minimized &&
              // && !showMinimize
              showAssistantToolTip && (
                <div className="chattooltip bounce1" timeOut={2000}>
                  Ask Assistant
                </div>
              )}
            {showMinimize && showChatToolTip ? (
              <>
                {showChatInProgressToolTip && (
                  <div className="msgnum bounce1">Chat in Progress</div>
                )}

                {!minimized && (
                  <div
                    className="help-stick"
                    onClick={() => {
                      if (!showOverlay) {
                        setMinimized(false);
                        if (
                          props.launchOnButton === undefined ||
                          !props.launchOnButton ||
                          props.openChat
                        ) {
                          window.parent.postMessage(
                            {
                              chatMaximized: "true",
                            },
                            "*" //or "www.parentpage.com"
                          );
                        }

                        props.launchOnButton === undefined ||
                          !props.launchOnButton ||
                          (props.openChat && handleHistory());
                        sendOnAppOpen();
                        setShow(true);
                        setMaximized(true);
                        setShowClose(false);
                        setShowMinimize(false);
                        sth && setSth(true);
                        // startLogin()
                      }
                    }}
                  >
                    <div className="help-man ">
                      <img src={femaleuser} height="30" alt="" />
                      {/* {console.log("ha-pfixed")} */}
                    </div>
                    <div className="help-text">
                      Get Help <br />
                      Assistant
                    </div>
                  </div>
                )}
              </>
            ) : (
              //this is where minimized is true and icon appears
              minimized && (
                <div
                  className="help-stick"
                  // onClick={async() => {

                  //   if (!showOverlay) {
                  //     if (
                  //       props.launchOnButton === undefined ||
                  //       !props.launchOnButton
                  //     ) {

                  //      await  window.parent.postMessage(
                  //         {
                  //           chatMaximized: "true",
                  //         },
                  //         "*" //or "www.parentpage.com"
                  //       );
                  //       }

                  //   }
                  //   if (login) {
                  //     !props.launchOnButton && chatReopenFunction();
                  //   }

                  //   setMinimized(false);
                  //   // setShowSecondOk(true);
                  //   // sendOnAppOpen();
                  //   // setMaximized(true);
                  //   // setShow(true);
                  //   // setShowClose(false);
                  //   // setShowMinimize(false);
                  //    localStorage.setItem("linkLoginOnce", true);
                  //    localStorage.removeItem("linkLoginOnce");

                  // }}
                  onTouchStart={() => {
                    if (!showOverlay) {
                      if (
                        props.launchOnButton === undefined ||
                        !props.launchOnButton ||
                        props.openChat
                      ) {
                        window.parent.postMessage(
                          {
                            chatMaximized: "true",
                          },
                          "*" //or "www.parentpage.com"
                        );
                      }
                    }
                  }}
                  onMouseEnter={() => {
                    if (!showOverlay) {
                      if (
                        props.launchOnButton === undefined ||
                        !props.launchOnButton ||
                        props.openChat
                      ) {
                        window.parent.postMessage(
                          {
                            chatMaximized: "true",
                          },
                          "*" //or "www.parentpage.com"
                        );
                      }
                    }
                  }}
                  onMouseLeave={() => {
                    if (!showOverlay) {
                      if (
                        props.launchOnButton === undefined ||
                        !props.launchOnButton ||
                        props.openChat
                      ) {
                        window.parent.postMessage(
                          {
                            chatMinimized: "true",
                          },
                          "*" //or "www.parentpage.com"
                        );
                      }
                    }
                  }}
                  onClick={() => {
                    console.log("trigger on icon");
                    if (!showOverlay) {
                      setMinimized(false);
                    }
                    if (login) {
                      !props.launchOnButton && chatReopenFunction(localStorage.getItem("token"));
                    }
                    // }else{
                    //   startLogin()  
                    // }
                    // localStorage.setItem("linkLoginOnce", true);
                    //  localStorage.removeItem("linkLoginOnce");

                    // setShowSecondOk(true);
                    // sendOnAppOpen();
                    // setMaximized(true);
                    // setShow(true);
                    // setShowClose(false);
                    // setShowMinimize(false);
                  }}
                >
                  <div className="help-man">
                    <img src={femaleuser} height="30" alt="" />
                  </div>
                  <div className="help-text">
                    Get Help <br />
                    Assistant
                  </div>
                </div>
              )
            )}
          </div>
          {!minimized  &&(
            <div
             onScroll={onScroll}
              className="help-chat-box chatIn-header help-assistantwrapp hbc0 maximize"
              style={{ visibility: maximized ? "visible" : "hidden" }}
              id="top"
              key={backToMenuRender}
            >
               
              {showClose && (
                <>
                  <div className="chat-blkoverlay" style={{ display: "block" }}   >
                    {/* {console.log("ha-301")} */}
                    <div
                      className="confirmContr"
                      style={{ zIndex: 999999999999999 }}
                    >
                      <p style={{ paddingLeft: "10%", paddingRight: "10%" }}>
                        {" "}
                        Are you sure you want to close this conversation?
                      </p>
                      <div className="btn-contr mT20">
                        <button
                          className="btn btn-primary waves-effect waves-light w-auto chatclose-yes"
                          style={{
                            cursor: "pointer",
                            height: "36px",
                            lineHeight: "35px",
                          }}
                          onClick={() => {
                            console.log(props.launchOnButton,props.openChat,"issueiss")
                            if (
                             ( props.launchOnButton === undefined ||
                              !props.launchOnButton )|| (props.openChat && props.launchOnButton)
                              
                            ) {
                              window.parent.postMessage(
                                {
                                  chatMinimized: "true",
                                },
                                "*" //or "www.parentpage.com"
                              );
                            }
                            ( props.openChat === null||props.openChat === undefined ) &&  props.launchOnButton   ? closeEntireChat() :setShowAssistantToolTip(true);
                             
                             
                            // setJumpNode(false)
                            localStorage.setItem("jumpNode", false);
                            // localStorage.removeItem('redirectLinkFullScreen');
                            // handleCloseChat();

                            // setSth(false);
                            
                            sendOnAppClose();
                            setshowOverlay(false);
                            setShowHistory(false);
                            setTimeout(() => {
                              setShowAssistantToolTip(false);
                            }, 4000);
                            setChangedRefresh(true);
                            // setMaximized(true)
                            setMinimized(true);
                            setShowClose(false);
                          }}
                        >
                          Yes
                        </button>
                        <button
                          style={{
                            border: "1px solid #E1009D",
                            cursor: "pointer",
                            height: "36px",
                            textAlign: "center",
                            lineHeight: "35px",
                          }}
                          className="btn    waves-effect waves-light w-auto chatclose-no "
                          onClick={() => {
                            setShowClose(false);
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {/* {thirdOkay && <div className="black-overlay fix" style={{ display: "block" }}></div>} */}
              <div className="help-card-header left-gradient">
                <span className="chat-avtar">
                  <img src={helpicon} alt="" />
                </span>
                <span className="chat-avtar-detail bold">
                  {" "}
                  Get help Assistant{" "}
                </span>

                <i
                  className="icon-minus-1 mR10"
                  style={{ cursor: "pointer" }}
                  key="miniMizeButtonS360Chart"
                  onClick={() => {
                    
                    if (
                      props.launchOnButton === undefined ||
                      !props.launchOnButton  || props.openChat
                       
                    ) {
                      window.parent.postMessage(
                        {
                          chatMinimized: "true",
                        },
                        "*" //or "www.parentpage.com"
                      );
                    }
                    localStorage.setItem("jumpNode", true);
                    setMaximized(false);
                    setShowMinimize(true);

                    // // // localStorage.removeItem("filterApllied");
                    setShow(false);
                    setShowChatToolTip(true);
                    // setSth(true)
                    sendOnAppClose();
                    setshowOverlay(false);

                    // setClearHistory(false)
                    setTextMessage({
                      key1: "",
                      count: Math.random(0, 1),
                      dontSend: true,
                    });
                    setShowBackToButton(false);
                    setShowChatInProgressToolTip(true);
                    setTimeout(() => {
                      setShowChatInProgressToolTip(false);
                    }, 5000);
                    if(props.launchOnButton && (props.openChat === undefined || props.openChat=== null))
                      minimizeChat();
                  }}
                ></i>
                <i
                  className="icon-close-1"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setChatData([]);

                    setShowClose(true);
                    setTextMessage({
                      key1: "",
                      count: Math.random(0, 1),
                      dontSend: true,
                    });
                    handleRefresh();
                  }}
                ></i>
              </div>
              <div className="help-card-body my-custom-scrollbar my-custom-scrollbar-primary" onScroll={onScroll}>
                {showBackToButton && (
                  <>
                    <div className="bktotop">
                      <button
                        onClick={async () => {
                          
                          await backToMenuFunction();
                        }}
                        className="button"
                      >
                        <span>
                          <img src={backtopmenu} alt="" />
                        </span>{" "}
                        Back to menu
                      </button>
                    </div>
                  </>
                )}

                <audio id="myAudio">
                  <source src="../done.mp3" type="audio/mpeg" />
                  Your browser does not support the audio element.{" "}
                </audio>
                <div
                  className="firstblk chat-section"
                  id="section0"
                  ref={myRef}
                
                >
                  {conversation && (
                    <Conversation
                    
                      //new addition 4
                      isLoading={isLoading}
                      currentData={currentData}
                      //
                      chatData={chatData}
                      jumpNode={jumpNode}
                      setLoginFromProps={(data) => setLogin(data)}
                      actionConfig={actionFromConfig}
                      thirdOkay={thirdOkay}
                      handleThirdOkay={handleThirdOkay}
                      {...props}
                      historyData={historyData}
                      setLoginLoader={setLoginLoader}
                      setLogin={setLogin}
                      setHistoryData={setHistoryData}
                      sth={sth}
                      showHistory={showHistory}
                      historyLoader={historyLoader}
                      loginLoader={loginLoader}
                      name={name}
                      login={login}
                      auth={auth}
                      setAuth={setAuth}
                      textMessage={textMessage}
                      handleInputBox={handleInputBox}
                      handleDontSend={() =>
                        setTextMessage({
                          key1: "",
                          count: Math.random(0, 1),
                          dontSend: true,
                        })
                      }
                      outSideLink={outSideLink}
                      tempLinkDetails={tempLinkDetails}
                    />
                  )}
                  {/* {console.log("ha-con355")} */}
                </div>
              </div>
              {enableDefaultTextBox && (
                <div className="text-area-input-box-container">
                  <textarea
                    id="tx"
                    maxRows={4}
                    style={{
                      maxHeight: "128px",
                      opacity: enableDefaultTextBox ? "100%" : "50%",
                    }}
                    ref={messageRef}
                    className="text-area-input-box"
                    aria-label="empty textarea"
                    placeholder="Type your query..."
                    onChange={(e) => handleChange(e)}
                    onKeyPress={handleKeyPress}
                    disabled={!enableDefaultTextBox}
                  />

                  {/* <div onClick={onMessageSend}>
                                <img style={{cursor:"pointer"}}  src={attachIcon} alt={attachIcon} height="20px" width="20px" />
                            </div> */}
                  <div onClick={onMessageSend}>
                    {typedFlag.length === 0 ? (
                      <img
                        style={{ cursor: "pointer" }}
                        src={sendIconGrey}
                        alt={sendIcon}
                        height="20px"
                        width="20px"
                        onClick={() => handleNewLink()}
                      />
                    ) : (
                      <img
                        style={{ cursor: "pointer" }}
                        src={sendIcon}
                        alt={sendIconGrey}
                        height="20px"
                        width="20px"
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          )}

         
        </>
      )}
    </Fragment>
  );
};

export default HelpAssistant;
